import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import style from '../../administration/adm.module.css'
import { api } from "../../../services/api";

import Table from 'rc-table';
import Swal from 'sweetalert2';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

import { GoPerson } from 'react-icons/go'
import { FaTrash } from 'react-icons/fa'
import { BsPerson } from 'react-icons/bs'
import InputAdornment from "@material-ui/core/InputAdornment";

import TitlePages from "../../../components/titleConfigs";
import Label from "../../../components/label";
import AddButton from "../../../components/buttonAdd";
import Spinner from '../../../components/spinner';

const Toast = Swal.mixin({
    toast: true,
    position: 'top',
    showConfirmButton: false,
    timer: 2000,
    width: 400,
    timerProgressBar: false,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})

export default function UsersActives() {

    const navigate = useNavigate()
    const [loading, setLoading] = useState([])
    const [selectedUsersName, setSelectedUsersName] = useState('')
    const [userId, setUsersId] = useState('')

    const [usersInactive, setUsersInactive] = useState('')
    const [users, setUsers] = useState([])

    async function getUsers() {
        setLoading(true)
        let responseUsers = await api.get('/users')

        let usersArray = []
        responseUsers.data.map(x => {
            usersArray.push({ label: x.name, value: x.id })
        })

        setUsers(usersArray)
        setLoading(false)
    }

    async function getIsInactive() {
        setLoading(true)
        let response = await api.get('/isInactive/users')
        setUsersInactive(response.data)
        setLoading(false)
    }

    useEffect(() => {
        getUsers();
        getIsInactive();
    }, []);

    const columns = [
        {
            title: "Admins",
            dataIndex: ["name"],
            key: "name",
            align: "left",
            width: '95%',

        },
        {
            title: '',
            dataIndex: '',
            key: '',
            align: "right",
            with: '10%',
            render: (value, row, id) => {
                return (<div onClick={() => handleRemoveAdmin(row.id)} style={{ display: 'flex', cursor: 'pointer', width: '1.5rem', height: '1.5rem', alignItems: 'center', justifyContent: 'center', borderRadius: '4px' }}><FaTrash color='#5A5A5A' size={14} /></div>)
            }
        },
    ];

    function handleRemoveAdmin(id) {
        Swal.fire({
            title: 'Deseja ativar esse usuário?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: "#009EBE",
            cancelButtonColor: "#636e72",
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar',
            allowOutsideClick: false
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    setLoading(true)
                    let responseAdmin = await api.put(`/admins/active/${id}`, {
                        isActive: true
                    })
                    if (responseAdmin.status == 200) {
                        Toast.fire({
                            title: 'Usuário ativado com sucesso',
                            icon: 'success'
                        })
                    }
                    await getIsInactive()
                } catch (error) {
                    Toast.fire({
                        icon: 'error',
                        title: `${error.response.data}`
                    })
                }
                setLoading(false)
            }
        })
    }

    const [errorAdm, setErroAdm] = useState('')
    let validated = []
    function validation() {
        validated = true
        if (userId == '') {
            setErroAdm('Inclusão inválida! É necessário pesquisar o colaborador e clicar em seu nome antes de adicionar.')
            validated = false
            return false
        }
        if (usersInactive.filter(x => x.id == userId).length > 0) {
            Toast.fire({
                title: 'Esse usuário já foi inativado.',
                icon: 'error'
            })
            validated = false
            return false
          }
    }


    async function addUsersInactive() {
        validation();
        if (validated == false) {
            return false
        }
        try {
            setLoading(true)
            let response = await api.put(`/admins/active/${userId}`, {
                isActive: false
            })

            if (response.status == 200) {
                Toast.fire({
                    title: 'Usuário inativado com sucesso',
                    icon: 'success'
                })
            }
            await getIsInactive()
            setSelectedUsersName('')
            setUsersId('')
        } catch (error) {
            Toast.fire({
                icon: 'error',
                title: `${error.response.data}`
            })
        }
        setLoading(false)
    }

    function handleSelectedAdmin(value) {
        setUsersId(value.value)
    }

    return (
        <>
            <div className={style.admContainer}>
                {loading == true ? (
                    <div className="spinner">
                        <Spinner animation="border" />
                    </div>
                ) : (
                    <div></div>
                )}
                <TitlePages icon={<GoPerson color='#009ebe' size={21} />} title='Cadastro de usuários inativos' funcao={() => navigate('/')} />
                <div>
                    <Label>Usuários inativos</Label>
                    <div style={{ display: 'flex', gap: '1rem', alignItems: 'flexStart', marginTop: '0.5rem', width: '27vw', height: '2rem', justifyContent: 'spaceBetween' }}>
                        <Autocomplete
                            freeSolo
                            id="free-solo-2-demo"
                            disableClearable
                            sx={{ width: 355 }}
                            options={users}
                            inputValue={selectedUsersName}
                            onInputChange={(event, newInputValue) => {
                                setErroAdm('')
                                setUsersId('')
                                setSelectedUsersName(newInputValue);
                            }}
                            onChange={(event, value) => {
                                handleSelectedAdmin(value)
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Inativar usuário"
                                    InputProps={{
                                        ...params.InputProps,

                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <BsPerson color="#aaa6a6" size={20} />
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            )}
                        />
                        <AddButton onClick={() => addUsersInactive()} />
                    </div>
                    {errorAdm ? (
                        <div className="inputError">{errorAdm}</div>
                    ) : null}
                </div>

                <div style={{ width: '27vw', overflow: 'auto', padding: '0.1rem', maxWidth: '405px',  height: '70%' }}>
                    <Table
                        sticky={true}
                        columns={columns}
                        showHeader={false}
                        data={usersInactive}
                        rowKey="id"
                        emptyText="Nenhum usuário inativo cadastrado!"
                    />
                </div>
            </div>
        </>
    )
}